import axios from 'axios';
import qs from 'qs';
import _ from "lodash";
import { getBaseUrl } from "@/util/app";
import { Toast } from 'vant';

const http = axios.create({
    baseURL: getBaseUrl(),
    timeout: 10000,
})
// 添加请求拦截器
http.interceptors.request.use(function (config) {
    if (config.method === "post" && config.headers['Content-Type'] != 'multipart/form-data'){
        config.headers['Content-Type'] == 'application/x-www-form-urlencoded'
        config.data = qs.stringify(config.data);
    }
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器
http.interceptors.response.use(function (response) {
    return response.data;
}, function (error) {
    //hideLoad() //隐藏加载提示
    // 处理错误
    if(_.has(error, 'response.status')) {
        switch (error.response.status) {
            case 401:
                error.message = '未授权，请登录';
                break;
            case 403:
                error.message = '拒绝访问';
                break;
            case 500:
                error.message = '服务器内部错误';
                break;
            case 404:
                error.message = `请求地址不存在：${error.response.config.url}`;
                break;
            default:
                error.message = error.response.data.errorMessage;
        }
    }
    Toast(error.message);
    return Promise.reject(error);
});


export default http;

